import Modal from './modal';
export default class Alert extends Modal {
  constructor(options) {
    super(options);
  }

  render() {
    let alertsContainer = document.querySelector('.alerts');
    if (!alertsContainer) {
      return;
    }

    if (this.opts.containerClass) {
      alertsContainer.classList.add(this.opts.containerClass);
    }
    alertsContainer.appendChild(
      this.createEl(`
      <div class="alert ${this.opts.mainClass}">
        <div class="alert-content">
          <div class="alert-header">
            <img class="alert-header-image">
            <div class="alert-header-title title title-s"></div>
            <div class="alert-header-text"></div>
          </div>
          <div class="alert-body"></div>
          <div class="alert-footer d-flex flex-wrap"></div>
        </div>
      </div>`)
    );
  }
  reBuild() {
    this.render();
    this.initialize();
    this.selector = '.' + this.opts.mainClass;
    this.modal = document.querySelector(this.selector);
  }
  initialize() {
    if (this.opts.imgSrc) {
      this.modal.querySelector('.alert-header-image').src = this.opts.imgSrc;
    } else {
      this.modal.querySelector('.alert-header-image').style.display = 'none';
    }
    if (this.opts.title) {
      this.modal.querySelector('.alert-header-title').innerHTML = this.opts.title;
    }
    if (this.opts.text) {
      this.modal.querySelector('.alert-header-text').innerHTML = this.opts.text;
    }
    if (this.opts.body) {
      this.modal.querySelector('.alert-body').innerHTML = this.opts.body;
    }
    if (this.opts.bodyEl) {
      this.modal.querySelector('.alert-body').appendChild(this.opts.bodyEl);
    }
    if (this.opts.buttons) {
      this.modal.querySelector('.alert-footer').innerHTML = this.opts.buttons;
    }
    if (this.opts.closeButtons) {
      this.modal
        .querySelector('.alert-header-title')
        .appendChild(this.createEl('<div class="btn btn-close btn-icon icon-times-b alert-close"></div>'));
    }
  }
  addCloseEvent() {
    if (this.modal.querySelector('.alert-close')) {
      this.modal.querySelector('.alert-close').addEventListener('click', () => {
        if (!this.modal || !this.modal.parentNode) {
          return;
        }
        this.modal.parentNode.removeChild(this.modal);
      });
    }
    this.modal.addEventListener('click', (e) => {
      if (e.target === this.modal) {
        this.modal.parentNode.removeChild(this.modal);
      }
    });
  }
  clearButtons() {
    this.modal.querySelector('.alert-footer').innerHTML = '';
  }
  setButtons(buttons) {
    this.modal.querySelector('.alert-footer').innerHTML = buttons;
    this.addCloseEvent();
  }
  createEl(domstring) {
    const html = new DOMParser().parseFromString(domstring, 'text/html');
    return html.body.firstChild;
  }
}
